import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitoaurangabadcab() {



const cardData = {
  keyword: "Mumbai to Aurangabad Cab",

headingDescription:
  "Omshree Cab offers reliable and comfortable Mumbai to Aurangabad cab services for travelers seeking a smooth journey to one of Maharashtra’s historic and culturally rich cities. Whether you are planning a heritage tour, a pilgrimage trip, a family vacation, or a corporate outing, our cab service ensures safe and convenient travel with experienced drivers and well-maintained vehicles. We provide flexible booking options including one-way, round-trip, and multi-day travel plans at transparent per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With professional chauffeurs skilled in long-distance highway driving, punctual pickups from anywhere in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Aurangabad cab services.",

topPlaces: [
  {
    title: "Ajanta Caves",
    description:
      "Ajanta Caves are a UNESCO World Heritage Site near Aurangabad, famous for their exquisite rock-cut Buddhist cave temples and intricate murals dating from the 2nd century BCE to 480 CE. Visitors can explore the beautifully preserved paintings, sculptures, and architecture that depict the life and teachings of Buddha. Traveling by cab ensures a comfortable journey, allowing travelers to spend ample time exploring the caves without worrying about local transport, and enjoy scenic drives through the surrounding hills and countryside."
  },
  {
    title: "Ellora Caves",
    description:
      "Ellora Caves are another UNESCO World Heritage Site near Aurangabad, renowned for their impressive rock-cut temples representing Hindu, Buddhist, and Jain traditions. The site includes the magnificent Kailasa Temple, which is carved out of a single rock and showcases extraordinary craftsmanship. A cab ride provides flexible and comfortable access to the caves, letting visitors explore multiple monuments at their own pace, capture photographs, and appreciate the historical significance without transport hassles."
  },
  {
    title: "Bibi Ka Maqbara",
    description:
      "Bibi Ka Maqbara, often called the 'Mini Taj Mahal,' is a stunning Mughal-era mausoleum in Aurangabad built in memory of Dilras Banu Begum. The monument features intricate marble work, beautiful gardens, and serene surroundings. Traveling by cab allows visitors to reach the site conveniently, explore the mausoleum leisurely, enjoy photography, and combine the visit with other nearby attractions without stress."
  },
  {
    title: "Daulatabad Fort",
    description:
      "Daulatabad Fort is a historic hill fort near Aurangabad known for its strategic design, steep ramparts, and panoramic views of the surrounding region. The fort has a rich history, having served as a capital for medieval rulers and witnessed numerous battles. A cab ride provides comfortable access to the fort, allowing visitors to explore the fortifications, gates, and temples at a relaxed pace while enjoying the scenic drive to the site."
  },
  {
    title: "Grishneshwar Temple",
    description:
      "Grishneshwar Temple is one of the twelve Jyotirlingas dedicated to Lord Shiva and is located close to the Ellora Caves. The temple attracts devotees seeking spiritual blessings and offers an architectural glimpse into Maratha-style temple design. Traveling by cab allows pilgrims to reach the temple conveniently, manage their schedule efficiently, and combine their visit with Ellora or other nearby attractions without transport concerns."
  },
  {
    title: "Aurangabad Caves",
    description:
      "Aurangabad Caves are a group of twelve rock-cut Buddhist caves situated on a hill near the city, featuring intricate sculptures and carvings dating back to the 6th–8th centuries CE. Visitors can explore the serene environment, ancient artwork, and historical significance of the caves. A cab service ensures easy access, flexible timing, and a comfortable visit without having to navigate challenging local transport or long distances on foot."
  },
  {
    title: "Salim Ali Lake",
    description:
      "Salim Ali Lake is a scenic lake in Aurangabad named after the famous ornithologist Salim Ali. The lake is a peaceful spot for nature walks, bird watching, and photography, attracting both tourists and locals. Traveling by cab allows visitors to enjoy a relaxed visit to the lake, combine it with other city sightseeing, and return comfortably without worrying about public transport or parking."
  },
  {
    title: "Pitalkhora Caves",
    description:
      "Pitalkhora Caves, located near Aurangabad, are ancient rock-cut Buddhist caves dating back to the 2nd century BCE. The site features stupas, sculptures, and inscriptions set amidst scenic surroundings. A cab ride provides convenient access, enabling travelers to explore the caves at their own pace, enjoy the natural environment, and include the site as part of a broader Aurangabad heritage itinerary."
  },
  {
    title: "Salim Ali Bird Sanctuary",
    description:
      "Salim Ali Bird Sanctuary near Aurangabad is a haven for bird watchers and nature enthusiasts. It features a variety of migratory and resident birds, offering opportunities for photography and ecological study. Traveling by cab ensures comfortable access to the sanctuary, flexible timing for exploration, and the ability to combine the visit with other attractions like Salim Ali Lake and the city’s historical sites."
  },
  {
    title: "Siddharth Garden and Zoo",
    description:
      "Siddharth Garden and Zoo in Aurangabad is a family-friendly destination featuring landscaped gardens, a small zoo, and recreational areas. Visitors can enjoy leisurely walks, interact with animals, and relax amidst greenery. A cab ride makes it easy to reach the zoo and plan a comfortable half-day or full-day outing while visiting other Aurangabad attractions efficiently."
  }
],

services: [
{
name: "Mumbai to Aurangabad Cab",
description: "Mumbai to Aurangabad cab service provides comfortable long-distance travel from Mumbai to the historic city of Aurangabad (Chhatrapati Sambhajinagar). Our AC sedans, SUVs, and premium vehicles ensure a smooth highway journey. Professional drivers are experienced with long-distance routes and ensure safe travel. Pickup is available from homes, hotels, offices, and Mumbai airport. Ideal for family travel, tourism, and business trips."
},
{
name: "Mumbai to Aurangabad Taxi",
description: "Mumbai to Aurangabad taxi service offers convenient intercity transportation for travelers visiting the cultural and historical city. Comfortable AC vehicles ensure relaxed seating for long-distance journeys. Experienced drivers ensure safe highway travel. Flexible pickup options are available across Mumbai. Perfect for family trips, tourism, and corporate travel."
},
{
name: "Mumbai to Aurangabad Cab Service",
description: "Mumbai to Aurangabad cab service is designed for passengers seeking reliable and comfortable intercity travel. Well-maintained vehicles and trained drivers ensure smooth highway journeys. Pickup is available from any location in Mumbai including airport terminals. AC interiors make long-distance travel relaxing."
},
{
name: "Mumbai to Aurangabad Taxi Service",
description: "Mumbai to Aurangabad taxi service offers dependable transportation for tourists and business travelers. Comfortable AC vehicles ensure relaxed travel on long routes. Professional drivers provide safe driving on highways. Flexible booking options make travel planning easy."
},
{
name: "Cab from Mumbai to Aurangabad",
description: "Cab from Mumbai to Aurangabad provides a convenient private travel option for passengers planning intercity journeys. Comfortable vehicles ensure smooth highway travel. Experienced drivers ensure safe and timely arrival. Ideal for tourism, business travel, and family trips."
},
{
name: "Taxi from Mumbai to Aurangabad",
description: "Taxi from Mumbai to Aurangabad offers reliable road transportation with comfortable vehicles and professional drivers. The service is ideal for tourists visiting Ajanta and Ellora caves and business travelers. Flexible pickup options across Mumbai ensure convenient travel planning."
},
{
name: "Mumbai to Aurangabad Cab Booking",
description: "Mumbai to Aurangabad cab booking allows travelers to reserve vehicles easily for long-distance journeys. Instant booking confirmation and flexible pickup options simplify trip planning. Sedan, SUV, and premium vehicles are available."
},
{
name: "Mumbai to Aurangabad Taxi Booking Online",
description: "Online taxi booking from Mumbai to Aurangabad allows passengers to reserve vehicles instantly from anywhere. Quick confirmation and easy scheduling simplify travel planning. AC vehicles and trained drivers ensure comfortable highway journeys."
},
{
name: "Mumbai to Aurangabad Cab Price",
description: "Mumbai to Aurangabad cab price offers transparent and competitive fare options for travelers. Customers can choose sedan, SUV, or luxury vehicles depending on budget and comfort needs. Clear pricing ensures no hidden charges."
},
{
name: "Mumbai to Aurangabad Taxi Fare",
description: "Mumbai to Aurangabad taxi fare is calculated with transparent per-km pricing and simple billing. Travelers receive affordable travel options with clear fare structure. Comfortable vehicles ensure relaxed intercity travel."
},
{
name: "Mumbai to Aurangabad One Way Cab",
description: "One way cab from Mumbai to Aurangabad is ideal for travelers who only require drop service without paying return charges. This option helps reduce travel costs significantly. AC vehicles ensure comfortable highway travel."
},
{
name: "Mumbai to Aurangabad Round Trip Taxi",
description: "Round trip taxi from Mumbai to Aurangabad offers convenient return travel for passengers planning sightseeing or business trips. Flexible return scheduling allows travelers to explore the city comfortably."
},
{
name: "Mumbai to Sambhajinagar Cab",
description: "Mumbai to Sambhajinagar cab service provides reliable travel to Chhatrapati Sambhajinagar (Aurangabad). Comfortable AC vehicles and experienced drivers ensure smooth highway journeys. Ideal for tourism and business travel."
},
{
name: "Mumbai to Aurangabad Innova Cab",
description: "Innova cab from Mumbai to Aurangabad is ideal for families and group travelers needing spacious seating and luggage capacity. The premium MPV offers comfortable travel for long-distance journeys."
},
{
name: "Mumbai to Aurangabad Ertiga Cab",
description: "Ertiga cab from Mumbai to Aurangabad provides comfortable travel for medium-size families and groups. Spacious interiors and AC comfort ensure relaxed highway journeys."
}
],

tableData: [
["Mumbai to Aurangabad Cab","Mumbai to Aurangabad Taxi"],
["Mumbai to Aurangabad Cab Service","Mumbai to Aurangabad Taxi Service"],
["Cab from Mumbai to Aurangabad","Taxi from Mumbai to Aurangabad"],
["Mumbai to Aurangabad Cab Booking","Mumbai to Aurangabad Taxi Booking Online"],
["Mumbai to Aurangabad Cab Price","Mumbai to Aurangabad Taxi Fare"],
["Mumbai to Aurangabad One Way Cab","Mumbai to Aurangabad Round Trip Taxi"],
["Mumbai to Sambhajinagar Cab","Mumbai to Aurangabad Innova Cab"],
["Mumbai to Aurangabad Ertiga Cab","Best Cab Mumbai to Aurangabad"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Long-Distance Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in long-distance highway travel, especially on the Mumbai to Aurangabad route. They are familiar with the fastest routes, road conditions, and rest points along the way, ensuring a safe, smooth, and comfortable journey for passengers traveling to Aurangabad."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "Omshree Cabs follows a transparent fare structure for Mumbai to Aurangabad cab services. We clearly explain the per-kilometer rate, toll charges, and trip packages before booking so customers never face hidden costs or unexpected fees."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Whether you want to travel early in the morning, late at night, or anytime during the day, Omshree Cabs provides 24/7 cab booking support. Our team ensures quick confirmation and reliable service for your Mumbai to Aurangabad journey."
  },
  {
    WhyChooseheading: "Clean AC Vehicles",
    WhyChoosedescription: "All our vehicles are well-maintained, fully air-conditioned, and thoroughly cleaned before every trip. Long-distance travel becomes more relaxing when you ride in a hygienic and comfortable vehicle from our fleet."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "We offer flexible trip options including one-way cabs, round trips, and multi-day travel packages for Aurangabad sightseeing. Travelers can customize pickup time, travel stops, and return schedules as per their convenience."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a wide range of vehicles including sedan cars, spacious SUVs like Ertiga and Innova, and premium vehicles. Whether you are traveling solo, with family, or with a group, we provide the perfect vehicle for your journey."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "Our cab service provides convenient doorstep pickup from homes, offices, hotels, or airports anywhere in Mumbai. Our driver arrives on time so your trip to Aurangabad begins comfortably without travel hassle."
  },
  {
    WhyChooseheading: "Reliable & Punctual Service",
    WhyChoosedescription: "Omshree Cabs is known for punctuality and professional service. Our drivers prioritize passenger safety and ensure timely arrival in Aurangabad so you can travel stress-free."
  }
]
};


const faqData = [
  { question: "What is the distance from Mumbai to Aurangabad by cab?", answer: "The distance from Mumbai to Aurangabad is approximately 340 km and usually takes around 6–7 hours by cab depending on traffic and road conditions." },
  { question: "Do you provide one-way Mumbai to Aurangabad cab services?", answer: "Yes, Omshree Cabs provides both one-way and round-trip cab services from Mumbai to Aurangabad." },
  { question: "Which vehicles are available for Mumbai to Aurangabad travel?", answer: "We offer sedans, SUVs like Ertiga and Innova, and premium vehicles depending on your group size and comfort preference." },
  { question: "Is pickup available from Mumbai Airport?", answer: "Yes, we provide direct pickup from Mumbai Airport for Aurangabad cab bookings." },
  { question: "Can we visit Ajanta and Ellora caves during the trip?", answer: "Yes, many travelers combine Aurangabad travel with Ajanta and Ellora caves sightseeing, and our drivers are familiar with these tourist locations." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, every vehicle provided by Omshree Cabs is fully air-conditioned for comfortable long-distance travel." },
  { question: "Can we stop during the journey for meals or rest?", answer: "Yes, passengers can request stops during the trip for food, refreshments, or rest breaks." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends, holidays, and tourist seasons." },
  { question: "Do you offer round-trip packages?", answer: "Yes, Omshree Cabs offers round-trip and multi-day packages for Aurangabad travel." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Vinay Kulkarni",
    feedback:
      "Booked Omshree Cabs for a Mumbai to Aurangabad trip with my family. The car was clean, the driver was polite, and the journey was very comfortable. Great service overall.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Deshmukh",
    feedback:
      "Excellent cab service for our Mumbai to Aurangabad travel. On-time pickup, smooth driving, and transparent pricing made the entire journey stress-free.",
    rating: 5
  }
];


























































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Aurangabad Cab",
  "description": "Book Mumbai to Aurangabad Cab with Omshree Cab for safe and comfortable outstation travel. Choose from Innova, Ertiga, and other taxis for one-way or round trips. Affordable fares, easy online cab booking, and reliable taxi service from Mumbai to Aurangabad (Sambhajinagar).",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2600"
  }
};




  return (
    <div>
      
<Helmet>
  <title>Mumbai to Aurangabad Cab | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Aurangabad Cab with Omshree Cab for safe and comfortable outstation travel. Choose from Innova, Ertiga taxis for one-way or round trips. Affordable fares, easy online cab booking, and trusted Mumbai to Aurangabad (Sambhajinagar) taxi service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/8.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoaurangabadcab;